import gql from 'graphql-tag';
import OrderRow from './fragmentOrderRow';

export default gql`
  query GetOrders($pickDate: String!) {
    orders(pickDate: $pickDate) {
      ...OrderRow
    }
  }
  ${OrderRow}
`;



// WEBPACK FOOTER //
// ./src/queries/getOrders.js